import React from 'react';

import { LottieAnimation } from '@common/ui/general';
// import Bolt from '~referral/images/icons/bolt.svg';
import BoltAnimation from '~referral/images/lottie/Bolt.lottie';

const Header = ({ title }) => (
  <div className="psm__form-header">
    <div className="psm__form-img-container psm__form-img">
      <LottieAnimation
        autoPlay
        loop
        mode="normal"
        src={BoltAnimation}
        style={{
        }}
      />
    </div>
    <div className="psm__form-content-container">
      <div className="nudge-shared-modal__header">
        {title}
      </div>
      <div className="nudge-shared-modal__attention-strip">
        Share your learning achievements so far on LinkedIn.
      </div>
    </div>
  </div>
);

export default Header;
